import React, { useContext } from 'react';
import FeatureContext, { IFeatureContext } from '../context/FeatureContext';

export const GetFeatureState = (featureSearchName: string) => {
  const featureFlags = useContext<IFeatureContext[]>(FeatureContext);

  if (featureFlags == null) {
    throw new Error("Context can only be used inside it's provider");
  }

  const featureEnabled = featureFlags.filter(
    (item) => item.featureName === featureSearchName
  );
  if (!featureEnabled || featureEnabled.length <= 0) return null;
  return featureEnabled[0].enabled;
};
